//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCityListApi } from '@/api/public';
export default {
  name: 'Index',
  props: {
    formCreateInject: Object,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: Boolean,
    timeType: {
      type: String,
      default: function _default() {
        return 'day';
      }
    },
    time: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    titleIpt: {
      type: String,
      default: function _default() {
        return '省市区';
      }
    },
    check: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem('city')) {
      this.getCityList();
    }
  },
  data: function data() {
    return {
      cityData: JSON.parse(localStorage.getItem('city')),
      title: this.titleIpt,
      timeData: {
        city: this.value.city
      }
    };
  },
  watch: {
    value: function value(n) {
      this.timeData = n;
    }
  },
  methods: {
    getCityList: function getCityList() {
      getCityListApi().then(function (res) {
        localStorage.setItem('city', JSON.stringify(res.data));
      });
    },
    changeDuration: function changeDuration() {
      this.$emit('input', this.timeData);
    }
  }
};